import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanels = _resolveComponent("TabPanels")!

  return (_openBlock(), _createBlock(_component_TabPanels, _normalizeProps(_guardReactiveProps({ ..._ctx.$props, ..._ctx.$attrs })), {
    default: _withCtx(({ selectedIndex }) => [
      _renderSlot(_ctx.$slots, "default", { selectedIndex: selectedIndex })
    ]),
    _: 3
  }, 16))
}